import {
  CONFIRMED_CREATE_PATIENT_GAPLD,
  CONFIRMED_DELETE_PATIENT_GAPLD,
  CONFIRMED_EDIT_PATIENT_GAPLD,
  CONFIRMED_GET_PATIENT_GAPLD,
} from "./PatientGapldType"
import {
  getPatientGapld,
  createPatientGapld,
  deletePatientGapld,
  updatePatientGapld,
  formatPatientGapld,
} from "../../services/PatientGapldService"
import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService"

function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey
  if (stateToken) return stateToken
  const storedUser = localStorage.getItem("userDetails")
  return storedUser ? JSON.parse(storedUser).token : null
}

// Helper to get patient_id from either source
function getPatientIdFromState(getState) {
  const prescriptionPatientDetails = getState().prescriptionState?.patientDetails
  const patientDetails = getState().patients?.patientDetails

  // Prioritize prescriptionState, then fallback to patientsState
  return prescriptionPatientDetails?.patient_id || patientDetails?.patient_id
}

export function getPatientGapldAction() {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState)
      const patient_id = getPatientIdFromState(getState)

      if (!patient_id) {
        showErrorAlert("Patient ID not found", "error")
        return
      }
      const response = await getPatientGapld(patient_id, token)
      if (response?.status === 200 && response.data?.status === "success") {
        const formattedData = formatPatientGapld(response.data.data)
        dispatch({ type: CONFIRMED_GET_PATIENT_GAPLD, payload: formattedData })
      } else {
        showErrorAlert("Failed to fetch GAPLD data", "error")
      }
    } catch (error) {
      console.error("Error fetching GAPLD data:", error)
      showErrorAlert("Something went wrong", "error")
    }
  }
}

export function createPatientGapldAction(data, history) {
  return async (dispatch, getState) => {
    try {
      const patient_id = getPatientIdFromState(getState) || data.patient_id

      if (!patient_id) {
        showErrorAlert("Patient ID not found", "error")
        return { success: false, message: "Patient ID not found" }
      }

      const requestData = {
        patient_id,
        gapld_id: data.gapld_id,

        pregnancy_status: data.pregnancy_status,
        marriage_info_id: data.marriage_info_id || "",

        delivery_date: data.delivery_date || "0000-00-00",
        abortion_date: data.abortion_date || "0000-00-00",

        pregnancy_month: data.pregnancy_month || "",

        How_was_the_delivery: data.How_was_the_delivery || "",
        gender: data.gender || "",
        which_rx_helped: data.which_rx_helped || "",

        child_born_alive: data.child_born_alive || "",
        death_within_28_days: data.death_within_28_days || "",
        death_after_28_days: data.death_after_28_days || "",
        currently_alive: data.currently_alive || "",
        death_timing: data.death_timing || "",

        how_did_miscarriage_happen: data.how_did_miscarriage_happen || "",
        miscarriage_reason: data.miscarriage_reason || "",
      }

      const response = await createPatientGapld(requestData)

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({ type: CONFIRMED_CREATE_PATIENT_GAPLD, payload: response.data.data })

        // 🔥 auto refresh GAPLD list
        // await dispatch(getPatientGapldAction())

        if (history) history.push("/patientgapld")
        handleSuccess("Entry created successfully!", "success")
        return { success: true, data: response.data.data }
      } else {
        showErrorAlert("Failed to create entry", "error")
        return { success: false, message: "Failed to create entry" }
      }
    } catch (error) {
      console.error(error)
      showErrorAlert("Failed to create entry", "error")
      return { success: false, message: error.message }
    }
  }
}



export function deletePatientGapldAction(entry, history) {
  return async (dispatch) => {
    try {
      await deletePatientGapld(entry)
      dispatch({ type: CONFIRMED_DELETE_PATIENT_GAPLD, payload: { gapld_id: entry.gapld_id } })
      if (history) history.push("/patientgapld")
      handleSuccess("Entry deleted successfully!", "success")
    } catch (error) {
      console.error(error)
      showErrorAlert("Failed to delete entry", "error")
    }
  }
}

export function updatePatientGapldAction(data, history) {
  return async (dispatch, getState) => {
    try {
      const patient_id = getPatientIdFromState(getState)

      if (!patient_id) {
        showErrorAlert("Patient ID not found", "error")
        return
      }
      const requestData = {
        patient_id,
        gapld_id: data.gapld_id,

        pregnancy_status: data.pregnancy_status,
        marriage_info_id: data.marriage_info_id || "",

        delivery_date: data.delivery_date || "0000-00-00",
        abortion_date: data.abortion_date || "0000-00-00",

        pregnancy_month: data.pregnancy_month || "",

        How_was_the_delivery: data.How_was_the_delivery || "",
        gender: data.gender || "",
        which_rx_helped: data.which_rx_helped || "",

        child_born_alive: data.child_born_alive || "",
        death_within_28_days: data.death_within_28_days || "",
        death_after_28_days: data.death_after_28_days || "",
        currently_alive: data.currently_alive || "",
        death_timing: data.death_timing || "",

        how_did_miscarriage_happen: data.how_did_miscarriage_happen || "",
        miscarriage_reason: data.miscarriage_reason || "",
      }

      const response = await updatePatientGapld(requestData)
      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({ type: CONFIRMED_EDIT_PATIENT_GAPLD, payload: { ...requestData, ...response.data.data } })
        await dispatch(getPatientGapldAction())
        if (history) history.push("/patientgapld")
        handleSuccess("Entry updated successfully!", "success")
      } else {
        showErrorAlert("Failed to update entry", "error")
      }
    } catch (error) {
      console.error(error)
      showErrorAlert("Failed to update entry", "error")
    }
  }
}
